import { FABRIC_TABS, FormContexts, FabricProviderType } from '../types';
import useIsUnifiedFabric from './useIsUnifiedFabric';

export type OrchestrationFabricInfo = {
  isOrchestrationFabric: boolean;
  isOldOrchestrationFabric: boolean;
};

const useIsOrchestrationFabric = (formContexts: FormContexts): OrchestrationFabricInfo => {
  const fabricProviderType = formContexts[FABRIC_TABS.providers].watch('fabricProviderType');
  // Use initialFabricProviderTypes instead of fabricProviderTypesV2
  // as initialFabricProviderTypes has only the types that are already created for the fabric
  const fabricProviderTypesV2 = formContexts[FABRIC_TABS.providers].watch('initialFabricProviderTypes');

  const isUnifiedFabric = useIsUnifiedFabric(formContexts);

  const isOldOrchestrationFabric = fabricProviderType === FabricProviderType.Orchestration;
  const isUnifiedOrchestrationFabric =
    isUnifiedFabric && Boolean(fabricProviderTypesV2?.includes(FabricProviderType.Orchestration));

  return {
    isOrchestrationFabric: isUnifiedOrchestrationFabric || isOldOrchestrationFabric,
    isOldOrchestrationFabric
  };
};

export default useIsOrchestrationFabric;
